import React, { Component } from 'react';
import {Redirect} from "react-router-dom";
import axios from 'axios';
import FormTextItem from "./FormTextItem";
import FormTextItemContacts from "./FormTextItem_Contacts";
import FormTextItemPaso5 from "./FormTextItem_Paso5";
import SecurityPlanService from "../services/SecurityPlan.service";

const SERVER_URL = process.env.REACT_APP_SERVER_URL;

export default class PagPlanSeguridad extends Component {
    state = {
        items: [],
        isLoggedIn: false,
        firstTime: true
    };

    async componentDidMount(){  
        const response = await axios.get(`${SERVER_URL}/api/isLoggedIn`, { withCredentials: true });
        this.setState({ isLoggedIn: response.data.isLoggedIn, firstTime: false });  

        if(response.data.isLoggedIn){
            const response = await SecurityPlanService.get();
            if (response.status !== 200) {
                alert(`Error: ${response.data.message}`);
            } else {
                this.setState({ items: response.data.items });;
            }
        }
    }

    render() {
        return (this.state.isLoggedIn || this.state.firstTime) 
        ?(  
            <React.Fragment>
                <FormTextItem
                    idCategory={0}
                    items={this.state.items}
                    title="Señales de alerta"
                    description="Lo primero es aprender a reconocer cuándo vas a tener una crisis. Ese es el momento 
                    en que vas a poner en marcha tu Plan de Seguridad.
                    ¿Cuál fue la gota que rebalsó el vaso? Pensá en las circunstancias que te llevaron a tener ideas 
                    suicidas o sentir ganas de hacerte daño. Puede ser una fecha, un comentario, un mensaje, una 
                    situación con alguien, cambios en tu estado de ánimo… Si podés, hacé este paso con una persona de confianza. 
                    A medida que vayas identificando estas señales, escribilas acá:"
                />
                <FormTextItem 
                    idCategory={1}
                    items={this.state.items}
                    title="Paso 1. Actividades que puedo hacer solx para no pensar"
                    description="Anotá actividades que podés hacer solx y te sirven para distraerte cuando te sentís
                        mal, para disminuir el malestar, o tranquilizarte. Puede ser alguna actividad física, salir a 
                        pasear al aire libre, escuchar música, jugar algún juego, ordenar, etc. Escribí 3 que podés
                        hacer de día y 3 que podés hacer de noche. "
                />
                <FormTextItem
                    idCategory={2}
                    items={this.state.items}
                    title="Paso 2. Con quiénes puedo hablar para distraerme"
                    description="Identificá cuáles son esas personas de tu entorno que te pueden ayudar a distraerte 
                    cuando te sentís mal."
                />
                <FormTextItem
                    idCategory={3}
                    items={this.state.items}
                    title="Paso 3. Con quiénes puedo hablar de lo que me pasa"
                    description="Anotá las personas de confianza (profesionales, familiares, amigxs) con las que
                        podés hablar honestamente de lo que te está pasando en el momento de crisis. Es importante 
                        que les avises que los vas a llamar para que te ayuden en esta situación."
                />
                <FormTextItemContacts
                    title="Paso 4. Listado de números de asistencia en mi ciudad"
                    description="Armá el listado de los números de emergencia a los que podés llamar en caso que 
                    los pasos anteriores no hayan servido para manejar la crisis."
                />
                <FormTextItemPaso5
                    title="Paso 5. Mantener un espacio seguro"
                    description="Si el plan no funciona para reducir la crisis y te sentís en riesgo, retirá los medios o 
                    métodos con los que puedas hacerte daño y LLAMÁ INMEDIATAMENTE A: "
                />
            </React.Fragment>
        )
        :<Redirect to="/" />
    }
}
